<template>
    <div class="search-suggestions-wrapper">
        <div v-show="$globalStore.isFocusedOnInput && $globalStore.searchQuery.length > 0" class="search-suggestions">
          <div class="sliders-container">
            <div class="input-group">
              <label :for="'maxPrice'" id="maxPriceLabel">
                  <span class="slider-label">Select Price: {{ maxPriceDisplay }}</span>
              </label>
              <input type="range"
                     id="maxPrice"
                     v-model="maxPrice"
                     :min="0"
                     :max="200"
                     :step="5"
                     class="slider"
                     aria-valuemin="0"
                     aria-valuemax="200"
                     :aria-valuenow="maxPrice"
                     aria-label="Price"
                     @click="unfocus"
                     @input="unfocus"/>
          </div>

          <!-- Percent Off Slider -->
          <div class="input-group">
              <label :for="'minPercentOff'" id="minPercentOffLabel">
                  <span class="slider-label">Percent Off: {{ minPercentOffDisplay }}</span>
              </label>
              <input type="range"
                     id="minPercentOff"
                     v-model="minPercentOff"
                     :min="0"
                     :max="99"
                     :step="5"
                     class="slider"
                     aria-valuemin="0"
                     aria-valuemax="99"
                     :aria-valuenow="minPercentOff"
                     aria-label="Percent Off"
                     @click="unfocus"
                     @input="unfocus"/>
          </div>


          <div class="search-suggestion-button" @click="search()"><button class="button-cta"><span class="material-symbols-outlined">search</span> Search</button></div>
          </div>
            <div v-for="suggestion in $globalStore.searchSuggestions" :key="suggestion" class="search-suggestion" @click="search(suggestion)">
              <div class="search-icon"><span class="material-symbols-outlined">search</span></div>
              <div class="search-suggestion-text">{{suggestion}}</div>
            </div>
          
        </div>
      </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { globalStore } from '@/stores/globalStore'
import { useRouter } from 'vue-router'

const router = useRouter()
const $globalStore = globalStore()

const maxPrice = ref<number>(0)
const minPercentOff = ref<number>(50)
const maxPriceDisplay = computed(() => {
    return maxPrice.value > 0 ? `$${maxPrice.value}` : 'Any';
});

const minPercentOffDisplay = computed(() => {
    return minPercentOff.value > 0 ? `${minPercentOff.value}%` : 'Any';
});

//onload, load from store
onMounted(() => {
    if($globalStore.maxPrice) {
        maxPrice.value = $globalStore.maxPrice
    }
    if($globalStore.minPercentOff) {
        minPercentOff.value = $globalStore.minPercentOff
    }
})

const unfocus = () => {
    // Empty function as per original
};

const search = (suggestion?: string | null) => {

    if(suggestion) {
        $globalStore.searchQuery = suggestion;
        $globalStore.clearCategoryNodes();
    }

    $globalStore.setMaxPrice(maxPrice.value);
    $globalStore.setMinPercentOff(minPercentOff.value);

    if($globalStore.searchQuery.length > 0) {       
        //blur
        (document.activeElement as HTMLInputElement)?.blur();
        $globalStore.setFocusedOnInput(false)
        router.push({ name: 'search-results', query: {  q: $globalStore.searchQuery, price: maxPrice.value, percent: minPercentOff.value } })     
    }
}

</script>


<style scoped>

.search-suggestions-wrapper {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  z-index: 1000;

}

.search-suggestions {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  z-index: 1000000;
}

.search-suggestion {
  padding: 10px;
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.search-icon {
  width: 20px;
  height: 20px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-group {
  display: grid;
}

.sliders-container {
  margin-top: 10px;
}

.search-suggestion-button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;
  margin-bottom: 10px;
}

@media all and (max-width: 980px) {

  .hide-search-results {
    display: none;
  }
}

</style>

